// ==== Scroll reveal + animación de entrada global ====
document.addEventListener('DOMContentLoaded', () => {
  // Selecciones seguras para Horizon (se aplican sin tocar plantillas)
  const selectorList = [
    '.shopify-section .banner',
    '.shopify-section .section-header',
    '.product-grid .grid__item',
    '.collection-list .grid__item',
    '.feature-row', '.rich-text', '.image-with-text', '.multicolumn',
    '.testimonials', '.newsletter', '.blog-posts', 'footer'
  ];

  // Marca como .reveal todos los nodos objetivo
  const targets = document.querySelectorAll(selectorList.join(','));
  targets.forEach(el => el.classList.add('reveal'));

  // IntersectionObserver para mostrar al entrar en viewport
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  }, { threshold: 0.18 });

  targets.forEach(el => io.observe(el));

  // Animación inmediata para el primer bloque (hero del home)
  const firstHero = document.querySelector('.shopify-section:first-of-type .banner, .shopify-section:first-of-type .hero, .slideshow');
  if (firstHero) {
    firstHero.classList.add('reveal');
    setTimeout(() => firstHero.classList.add('is-visible'), 100);
  }
});
